"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../../base-components/Icon/Icon");
var _Clear = require("../../../base-components/Clear/Clear");
var _Sanitizer = require("../../../base-components/Sanitizer/Sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProductListItem = exports.ProductListItem = function ProductListItem(_ref) {
  var icon = _ref.icon,
    iconColor = _ref.iconColor,
    children = _ref.children,
    styles = _ref.styles;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.listItem
  }, icon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    Svg: icon,
    color: iconColor,
    styles: {
      icon: styles.listItemIcon
    }
  }), /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    className: styles.listItemChildren,
    safelySetInnerHTML: children
  }), /*#__PURE__*/_react["default"].createElement(_Clear.Clear, null));
};
ProductListItem.propTypes = {
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  children: _propTypes["default"].node.isRequired,
  icon: _propTypes["default"].func.isRequired,
  iconColor: _propTypes["default"].string
};
ProductListItem.defaultProps = {
  styles: {},
  iconColor: '#006fcf'
};